import { Typography, Icon, MenuItem } from '@sanlam-glacier/app-common/components';
import { useDeleteProposal } from 'bff';
import {
  ContextMenuOptionProps,
  ContextMenuPromptProps,
  PromptData
} from 'modules/new-business/types/proposal/ContextMenuSharedTypes.type';

export const OverviewContextMenuDeleteItem = ({
  proposalId,
  disabled,
  handleClick
}: ContextMenuOptionProps & ContextMenuPromptProps) => {
  const { mutate } = useDeleteProposal({ deleteProposalCommand: { id: proposalId } });

  const handleClickEvent = () => {
    const promptData: PromptData = {
      action: () => async () => await mutate({ deleteProposalCommand: { id: proposalId } }),
      primaryButtonText: 'Delete proposal',
      promptText1: `You are about to delete proposal #${proposalId}.`,
      promptText2: 'Are you sure you want to delete it? This action cannot be undone.',
      promptTitle: 'Delete proposal?',
      secondaryButtonText: 'Cancel'
    };
    if (handleClick) handleClick(promptData);
  };

  return (
    <MenuItem
      adornmentStart={() => <Icon icon='action_delete' />}
      size={MenuItem.SIZE.SMALL}
      onClick={async () => {
        handleClickEvent();
      }}
      disabled={disabled}
    >
      <Typography align={Typography.ALIGN.LEFT} variant={Typography.VARIANT.B3}>
        Delete
      </Typography>
    </MenuItem>
  );
};
export default OverviewContextMenuDeleteItem;
